<template>
  <div>
    <div class="indicator">
      <body-parts
        v-if="$props.showBodyParts"
        class="bodyparts"
        :parts="$props.areas"
      />

      <div v-if="$props.index" class="index">
        <div class="text text-dark">{{ $props.index }}</div>
      </div>
      <div v-if="$props.showTime" class="duration">
        <div class="text">{{ $props.time | secsToMinutesSeconds }}</div>
      </div>
    </div>
    <div v-if="$props.showIntensity" class="intensity">
      <div
        :class="`intensity-bullet intensity-${$props.intensity}`"
        v-b-tooltip.hover
        :title="getIntensityTooltip($props.intensity)"
      />
    </div>
  </div>
</template>

<script>
import BodyParts from '@/elements/BodyParts';

export default {
  name: 'BodyPartsTimeIndocator',
  components: { BodyParts },
  methods: {
    getIntensityTooltip(intensity) {
      if (intensity === 3) return this.$t('BodyPartsTimeIndicator_intensity_3');
      if (intensity === 2) return this.$t('BodyPartsTimeIndicator_intensity_2');
      if (intensity === 1) return this.$t('BodyPartsTimeIndicator_intensity_1');
    },
  },
  props: {
    areas: {},
    time: {},
    intensity: {},
    index: {},
    showBodyParts: {
      default: true,
    },
    showTime: {
      default: true,
    },
    showIntensity: {
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.indicator {
  position: absolute;
  top: 5px;
  left: 5px;
}

.duration {
  margin: 0 0 0 5px;
  float: right;
  height: 22px;
  color: rgba(255, 255, 255, 0.9);

  padding: 1px;
  border-radius: 44px;
  background-color: rgba(255, 255, 255, 0.7);

  text-align: center;

  .text {
    padding: 0 5px;
    font-size: 12px;
    line-height: 20px;
    background-color: rgb(160, 198, 77);
    border-radius: 40px;
    height: 20px;
  }
}

.index {
  margin: 0 0 0 5px;
  float: left;
  height: 22px;
  min-width: 22px;
  color: rgba(255, 255, 255, 0.9);

  padding: 1px;
  border-radius: 44px;
  background-color: rgba(255, 255, 255, 0.7);

  text-align: center;

  .text {
    padding: 0 5px;
    font-size: 12px;
    line-height: 20px;
    background-color: rgb(160, 198, 77);
    border-radius: 40px;
    height: 20px;
  }
}

.bodyparts {
  height: 22px;
  padding: 1px;
  border-radius: 22px;
  background-color: rgba(255, 255, 255, 0.7);
}

.intensity {
  position: absolute;
  top: 5px;
  right: 5px;

  .intensity-bullet {
    height: 10px;
    width: 10px;
    border-radius: 20px;
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/elements/BodyPartsTimeIndicator.vue